var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "label",
        {
          staticClass: "el-form--label-top",
          class: { hiddenlabel: !_vm.fieldValue },
        },
        [_vm._v(_vm._s(_vm.placeholderValue) + " ")]
      ),
      _vm._v(" "),
      _vm.fieldType == "select"
        ? _c(
            "el-select",
            {
              staticClass: "w-100",
              attrs: {
                disabled: _vm.disabled,
                filterable: "",
                placeholder: _vm.placeholderValue,
              },
              on: {
                change: function ($event) {
                  return _vm.$emit("change")
                },
              },
              model: {
                value: _vm.fieldValue,
                callback: function ($$v) {
                  _vm.fieldValue = $$v
                },
                expression: "fieldValue",
              },
            },
            _vm._l(_vm.options, function (country, countryCode) {
              return _c("el-option", {
                key: "countrydrop_" + countryCode,
                attrs: { label: country, value: countryCode },
              })
            }),
            1
          )
        : _vm.fieldType == "textarea"
        ? _c("el-input", {
            attrs: { disabled: _vm.disabled, type: "textarea" },
            model: {
              value: _vm.fieldValue,
              callback: function ($$v) {
                _vm.fieldValue = $$v
              },
              expression: "fieldValue",
            },
          })
        : _c("el-input", {
            attrs: {
              placeholder: _vm.placeholderValue,
              disabled: _vm.disabled,
            },
            model: {
              value: _vm.fieldValue,
              callback: function ($$v) {
                _vm.fieldValue = $$v
              },
              expression: "fieldValue",
            },
          }),
      _vm._v(" "),
      [
        "job_title",
        "project_title",
        "state_country_of_production",
        "designer_name",
        "architect_name",
        "client",
        "contractor",
        "manufacturer",
        "photographer",
        "other",
        "design_team",
        "fax",
      ].indexOf(_vm.placeholder) >= 0
        ? _c("span", { staticClass: "input-hint" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.__(
                    "fieldnames.hint." +
                      (_vm.formName ? _vm.formName + "." : "") +
                      _vm.formStep +
                      "_" +
                      _vm.placeholder
                  )
                ) +
                "\n    "
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }